module.exports = __webpack_public_path__ + "img/img10.5579c409.png";